module.exports = __webpack_public_path__ + "img/my_apply.4a8e4b7f.png";